import React from "react";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { Spinner } from "@via/components/loading/loading.tsx";
import {
  BannerType,
  MessageBanner,
} from "@via/components/message-banner/message-banner";

interface PlanLimitNoticeInterface {
  billingInfo: any;
  inviteUserError?: any;
  onAgreeExtraUser: () => void;
  isLoading: boolean;
}

const PlanLimitNotice: React.FC<PlanLimitNoticeInterface> = ({
  billingInfo,
  inviteUserError,
  onAgreeExtraUser,
  isLoading,
}) => {
  const handleAgreement = () => {
    onAgreeExtraUser();
  };
  return (
    <div>
      {inviteUserError?.response?.data?.message && (
        <MessageBanner
          title="Payment Error"
          messages={inviteUserError?.response?.data?.message}
          type={BannerType.Error}
        />
      )}
      <div className="w-full mt-4 p-4 bg-white border border-gray-200 rounded-xl shadow-sm flex flex-wrap justify-between items-center gap-4">
        <div className="flex items-center gap-4">
          <div className="flex-shrink-0">
            <div className="w-8 h-8 flex items-center justify-center rounded-full border border-orange-100 bg-orange-50 text-orange-600">
              <ExclamationCircleIcon className="w-5 h-5" />
            </div>
          </div>
          <div className="flex flex-col flex-1">
            <div className="text-sm font-semibold text-gray-800">
              You’ve reached the maximum number of users allowed in your current
              plan.
            </div>
            <div className="text-sm mt-2 text-gray-500">
              {billingInfo?.message ?? "Each new user costs $300/year"}
            </div>
            <div className="text-sm mt-2 text-gray-500">
              This charge will be applied immediately.
            </div>
          </div>
        </div>
        <div className="flex flex-shrink-0 justify-end">
          <button
            onClick={handleAgreement}
            disabled={isLoading}
            data-testid="agree-add-member"
            className="inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            <Spinner loading={isLoading}>
              I understand and agree to this charge
            </Spinner>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanLimitNotice;
